import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5863d502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-contact-infos-field" }
const _hoisted_2 = { class: "editable-contact-infos-field__details" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "No contact person added", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "contact-persons-list"
}
const _hoisted_7 = { class: "contact-persons-list__name-types" }
const _hoisted_8 = { class: "contact-persons-list__name" }
const _hoisted_9 = { class: "contact-persons-list__types" }
const _hoisted_10 = { class: "contact-persons-list__mail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.contactPersons?.length==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactPersons, (cp) => {
              return (_openBlock(), _createElementBlock("div", {
                key: cp.email,
                class: "contact-persons-list__item"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(cp.name), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, _toDisplayString(cp.types.join(', ')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(cp.email), 1)
              ]))
            }), 128))
          ]))
    ]),
    (!_ctx.editingDisabled)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          onClick: _ctx.onChangeContactInfos,
          class: "editable-contact-infos-field__edit-icon",
          color: "grey-7",
          flat: "",
          round: "",
          icon: "mdi-pencil-outline"
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}